<template>
  <div class="avatar-card">
    <label class="avatar-clickable">
      <img
        v-if="displayUrl"
        :src="displayUrl"
        alt="Avatar utilisateur"
      />
      <div v-else class="avatar-placeholder">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
      </div>
      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        hidden
        @change="onFileChange"
      />
    </label>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { config } from '@/config/env.js'

const props = defineProps({
  avatarName: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['avatar-selected'])

const previewUrl = ref(null)

const displayUrl = computed(() => {
  if (previewUrl.value) {
    return previewUrl.value
  }
  if (props.avatarName) {
    return `${config.apiUrl}/uploads/avatars/${props.avatarName}`
  }
  return null
})

const onFileChange = (event) => {
  const file = event.target.files[0]
  if (!file) return

  console.log('Type de fichier:', file instanceof File)  // Doit être true
  console.log('Fichier:', file)

  // Preview locale
  if (previewUrl.value) {
    URL.revokeObjectURL(previewUrl.value)
  }
  previewUrl.value = URL.createObjectURL(file)

  // Émettre le fichier (pas l'URL)
  emit('avatar-selected', file)
}
</script>

<style scoped>
.avatar-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.avatar-clickable {
  cursor: pointer;
  display: inline-block;
  width: 280px;
  height: 280px;
}

.avatar-clickable img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid var(--color-jungle);
  display: block;
  transition: opacity 0.2s ease;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 8px solid var(--color-jungle);
  background: var(--color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-jungle);
  transition: opacity 0.2s ease, shadow 0.2s ease;
  box-shadow: var(--shadow-md);
}

.avatar-placeholder svg {
  width: 80%;
  height: 80%;
}

.avatar-clickable:hover img,
.avatar-clickable:hover .avatar-placeholder {
  opacity: 0.8;
  box-shadow: var(--shadow-lg);
}
@media (max-width: 768px) {
  .avatar-card {
    order: -1;
    width: 100%;
  }
  .avatar-clickable {
    width: 180px;
    height: 180px;
  }
  .avatar-placeholder {
    border: 4px solid var(--color-jungle);
  }
}
</style>

